import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
  minHeight: 100
}, props));
LoadingComponent.displayName = 'AsyncMoreActionsDropdownOptions';
const AsyncMoreActionsDropdownOptions = Loadable({
  loader: () => import( /* webpackChunkName: "more-actions-dropdown" */'conversations-thread-view/chat-feed-actions-header/components/ConnectedMoreActionsDropdownOptions'),
  LoadingComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncMoreActionsDropdownOptions;